import { WithStyles, withStyles } from '@mui/styles';
import React from 'react';

import { FirmsDashboard } from './firmsDashboard';
import { muiStyles } from './styles';

export interface FirmsDashboardProps extends WithStyles<typeof muiStyles>{
    setAssetListOverlayOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default withStyles(muiStyles)(FirmsDashboard);